module.exports = __webpack_public_path__ + "850645a464b6f785ad49f8e786bf092e.woff2";